import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Input from "../../../components/input/Input";
import Select from "../../../components/input/Select";
import ExportTable from "../../../components/button/ExportButton";
import MultipleSelect from "../../../components/input/MultipleSelect";
import ModalLeadDetails from "../Funnel/Modals/ModalLeadDetails";
//services
import { getLeads } from "../../../services/Crm/Leads/getLeads";
import { getStatusFunnel } from "../../../services/Crm/Settings/Status/getStatusFunnel";
import { getFunnelWithStatus } from "../../../services/Crm/Settings/Funnel/getFunnelWithStatus";
//utils
import { getContrastColor } from "../../../utils/getContrastColor";
//hooks
import usePermission from "../../../hooks/usePermission";
//context
import { useAppContext } from "../../../context/AppContext";

const Leads = () => {
  usePermission("254");
  const form = useForm();
  const errors = form.formState.errors;
  const { permissions } = useAppContext();
  const [leads, setLeads] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [tableToExport, setTableToExport] = useState(null);
  const [funnelsOptions, setFunnelsOptions] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [selectedLead, setSelectedLead] = useState(null);
  const [visibleDetails, setVisibleDetails] = useState(false);

  const { data: status, isLoading: isLoadingStatus } = useQuery({
    queryKey: [`statusFunnel`],
    queryFn: () => getStatusFunnel(),
  });

  const { data: funnels, isLoading: isLoadingFunnels } = useQuery({
    queryKey: [`funnels`],
    queryFn: () => getFunnelWithStatus(),
  });

  const items = [
    {
      template: () => (
        <Link to={"/crm/leads"} className="p-breadcrumb-link">
          Leads
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const columns = [
    { field: "name", header: "Nome" },
    { field: "phone", header: "Telefone" },
    { field: "email", header: "Email" },
    {
      field: "funnel",
      header: "Funil",
      body: (rowData) => rowData.funnels[0]?.name,
    },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        return (
          <>
            {rowData.status ? (
              <span
                className="badge"
                style={{
                  fontSize: "14px",
                  marginLeft: "5px",
                  backgroundColor: rowData.status.color,
                  color: getContrastColor(rowData.status.color),
                }}
              >
                {rowData.status.name}
              </span>
            ) : (
              <></>
            )}
          </>
        );
      },
    },
    // { field: "origin_id", header: "Origem" },
    {
      field: "broker",
      header: "Vendedor",
      body: (rowData) => rowData.broker?.name,
    },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const handleSearch = async (data) => {
    // console.log("Data", data);
    const formattedData = {
      ...data,
      ...(data.status_id && {
        status_id: data.status_id.map((status) => status.code).join(","),
      }),
    };

    // console.log("Formatted Data", formattedData);

    setLoading(true);
    const notification = toast.loading("Carregando Leads...");
    try {
      const response = await getLeads(formattedData);
      // console.log("Response", response);
      setLeads(response);
      setShowTable(true);
      toast.update(notification, {
        render: "Leads carregados com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      setLoading(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao carregar Leads!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      setLoading(false);
    }
    // setCanSearch(true);
  };

  // useEffect(() => {
  //   if (leads) {
  //     const formattedData = leads.map((lead) => ({
  //       id: lead.id,
  //       name: lead.name,
  //       phone: lead.phone,
  //       email: lead.email,
  //       origin_id: lead.origin_id,
  //       broker_id: lead.broker_id,
  //     }));
  //     setTableToExport(formattedData);
  //   }
  // }, [leads]);

  useEffect(() => {
    if (funnels?.funnels) {
      const options = funnels.funnels.map((funnel) => ({
        label: funnel.name,
        value: funnel.id,
      }));
      setFunnelsOptions([...options]);
    }
  }, [funnels]);

  useEffect(() => {
    if (status) {
      const options = status.map((s) => ({
        name: s.name,
        code: s.id,
      }));
      setStatusOptions([...options]);
    }
  }, [status]);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {/* <div className="col-md-3 d-flex justify-content-end align-items-center">
          <Button
            rounded
            label="Adicionar Lead"
            icon="pi pi-plus"
            // onClick={() => setVisible(true)}
          />
        </div> */}
      </div>
      <Panel title="Filtro de Leads">
        <form onSubmit={form.handleSubmit(handleSearch)}>
          <div className="row">
            <div className="col-md-3 mt-3">
              <Input
                name="name"
                label="Nome do Cliente"
                control={form.control}
                errors={errors}
              />
            </div>
            <div className="col-md-3 mt-3">
              <Select
                name="funnel_id"
                label={isLoadingFunnels ? "Carregando..." : `Funil de vendas`}
                disabled={isLoadingFunnels}
                errors={form.formState.errors}
                control={form.control}
                options={funnelsOptions}
              />
            </div>
            <div className="col-md-3 mt-3">
              <MultipleSelect
                name="status_id"
                control={form.control}
                options={statusOptions}
                disabled={isLoadingStatus}
                errors={form.formState.errors}
                label={isLoadingStatus ? "Carregando..." : `Status`}
              />
            </div>
            <div
              className={`col-md-2 d-flex align-items-end ${
                window.innerWidth < 962 ? "mt-3" : ""
              }`}
            >
              <div className="text-center w-100">
                <Button
                  type="submit"
                  icon="fa fa-search"
                  loading={loading}
                  aria-label="Search"
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
          </div>
        </form>
      </Panel>

      {loading && <Skeleton className="mt-4" width="100%" height={500} />}

      {showTable && !loading && (
        <Panel mainCss="mt-4">
          <ExportTable
            tableData={tableToExport}
            exportColumns={exportColumns}
            tabelaKey="Leads"
            onGlobalFilterChange={onGlobalFilterChange}
            globalFilterValue={globalFilterValue}
          />
          <DataTable
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            value={leads}
            paginator
            rows={10}
            sortableColumns={false}
            rowsPerPageOptions={[10, 25, 50]}
            // footerColumnGroup={footerGroup}
            globalFilter={globalFilterValue}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{
              minWidth: "1rem",
              fontSize: "0.8rem",
              border: "0.8rem",
            }}
          >
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
              />
            ))}
            {permissions?.includes("255") && (
              <Column
                header="Editar"
                body={(rowData) => (
                  <div className="text-center">
                    <Button
                      icon="fa-solid fa-pen-to-square"
                      onClick={() => {
                        setSelectedLead(rowData.id);
                        setVisibleDetails(true);
                      }}
                    />
                  </div>
                )}
              />
            )}
          </DataTable>
        </Panel>
      )}
      <ModalLeadDetails
        leadId={selectedLead}
        visible={visibleDetails}
        setVisible={setVisibleDetails}
      />
    </>
  );
};

export default Leads;
